import moment from "moment";
import Vue from 'vue';
import { router } from '@/router';
import ReportsService from '@/services/ReportsService';
import _ from 'lodash';
import store from '@/store';


function initialState() {
    return {
        AdvanceBookingReportsExcelFileName: null,
        AdvanceBookingReportsPDFFileName: null,
        dropDownObject: {
            fromDate: null,
            cinema_name: null,
            cinema_id: null,
        },
        AdvanceBookingReportData: [],
    }
}

const state = initialState();

const mutations = {
    SET_ADVANCE_BOOKIING_EXCEL_FILE_NAME: (state, payload) => {
        state.AdvanceBookingReportsExcelFileName = payload;
    },
    SET_ADVANCE_BOOKIING_PDF_FILE_NAME: (state, payload) => {
        state.AdvanceBookingReportsPDFFileName = payload;
    },
    SET_DROP_DOWN_VALUES: (state, payload) => {
        switch (payload.name) {
            case 'isCinema':
                state.dropDownObject.cinema_id = payload['selectedItem'] ? payload.selectedItem.cine_id : null;
                state.dropDownObject.cinema_name = payload['selectedItem'] ? payload.selectedItem.cine_name : null;
                break;
            case 'fromDate':
                state.dropDownObject.fromDate = payload['event'] ? payload['event'] : null;
                break;
            default: console.log('Advance Booking Report :( Sorry, we are enable to set value.');
        }
    },
    SET_ADVANCE_BOOKIING_REPORT: (state, payload) => {
        state.AdvanceBookingReportData = payload || []
    }
}

const actions = {
    onAdvanceBookingReportDropDownHandler: async ({ dispatch, commit, state }, payload) => {
        await commit('SET_DROP_DOWN_VALUES', payload);
    },
    onFetchAdvanceBookingReport: async ({ dispatch, commit, state }, payload) => {
        await commit('SET_ADVANCE_BOOKIING_REPORT', [])
        let loader = Vue.$loading.show();
        state.dropDownObject["fromDate"]=moment(state.dropDownObject["fromDate"]).format("YYYY-MM-DD")
        await ReportsService.GetAdvanceBookingReport(state.dropDownObject)
            .then(async (response) => {
                loader.hide();
                const { data } = response;
                if (data.status) {
                    commit('SET_ADVANCE_BOOKIING_REPORT', data.Records)
                    await commit('SET_ADVANCE_BOOKIING_EXCEL_FILE_NAME', data['ExcelName'] || null);
                    await commit('SET_ADVANCE_BOOKIING_PDF_FILE_NAME', data['PDFName'] || null);
                } else {
                    Vue.toasted.show(data.message);
                }
            }).catch((error) => {
                Vue.toasted.show("Catch Error on Municipalty Reports", error);
            });
    },
}

const getters = {
    getAdvanceBookingReportSelectedCinema: state => state.dropDownObject.cinema_name,
    getAdvanceBookingReportFromDate: state => state.dropDownObject.fromDate,
    getAdvanceBookingReportData: state => state.AdvanceBookingReportData,

    getAdvanceBookingReportsExcelFileName: state => state.AdvanceBookingReportsExcelFileName,
    getAdvanceBookingReportsPDFFileName: state => state.AdvanceBookingReportsPDFFileName,
}

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/AdvanceBookingReport.js